import React from "react";
import { Button } from 'react-bootstrap';
import CameraIcon from './../../../assets/icons/icnCameraCopy.svg';
import PlusIcon from './../../../assets/icons/icon-plus.svg';
import {default as t} from '../../utils/Translate';

const PhotoCreditPhotoUploadPage = props => (
    <div className="app-type app-spacers">
        <div className="app-view mb-md">
            <div className="photo-credit-container">
                <div className="photo-credit-container__title">{props.campaign.title_caption}</div>
                <div className="photo-credit-container__content">
                    <div className="photo-credit-container__content-box-secondpage">
                        <div className="photo-credit-container__content-title photo-credit-container__content-title-second">
                            {props.campaign.main_benefit_offerpage}
                        </div>
                        <div className="photo-credit-container__content-paragraph-container">
                            <div className="photo-credit-container__content-paragraph photo-credit-container__content-paragraph-second">
                                {props.photoCredit.gultigkeit_photocredit || photoCreditDefaultState.gultigkeit_photocredit}
                            </div>
                            <div className="photo-credit-container__content-paragraph-detail">
                            {t(`This is how you can participate: `, props.lang)}
                                <a
                                    className="photo-credit-container__content-paragraph-terms-and-conditions"
                                    href="#"
                                >
                                    {t(`Terms and Conditions`, props.lang)}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="photo-credit-photo-container">
                        <div className="photo-credit-upload-photo">
                            <div className="photo-credit-container__photo">
                                <Button>
                                    <div className="picture-upload-image-container">
                                        <div className="picture-upload-image-box">
                                            <div className="plus-icon">
                                                <picture>
                                                    <img src={PlusIcon} alt="Add" />
                                                </picture>
                                            </div>
                                        </div>
                                        <div className="camera">
                                            <picture>
                                                <img src={CameraIcon} alt="Camera" />
                                            </picture>
                                        </div>
                                    </div>
                                </Button>
                            </div>
                            <div className="photo-credit-container__content-brand-data photo-credit-container__content-brand-data-second-page">
                                <div className="photo-credit-container__photo-data">
                                {t(`Photo of the reciept`, props.lang)}
                                </div>
                                <div className="photo-credit-container__photo-detail">
                                {t(`Only front side - all information must be legible`, props.lang)}
                                </div>
                            </div>
                        </div>
                        <div className="photo-credit-upload-photo-notes">
                            <div className="photo-credit-upload-photo-notes__note">
                                {t(`The photo should ...`, props.lang)}
                            </div>
                            <ul className="photo-credit-upload-photo-notes__points">
                                <li>{t(`... be sharp`, props.lang)}</li>
                                <li>{t(`... be bright`, props.lang)}</li>
                                <li>{t(`... present the invoice legibly`, props.lang)}</li>
                            </ul>

                        </div>
                    </div>
                </div>
                <div className="photo-credit-submit-button-container">
                    <Button
                        className="photo-credit-submit-button btn btn--mobile"
                        disabled
                    >
                        {t(`Send`, props.lang)}
                    </Button>
                </div>
            </div>
        </div>
    </div>


);

const photoCreditDefaultState = {
aktionszeitraum_photocredit: "",
gultigkeit_photocredit: "",
key_facts_photocredit: "",
prozess_photocredit: "",
tc: ""
}

export default PhotoCreditPhotoUploadPage;



// WEBPACK FOOTER //
// ./src/components/ads/app/PhotoCreditPhotoUploadPage.js